import React from "react";
import "../../scss/News.css";

const NewsSettings = ({
  topicName,
  handleTopicChange,
  pageSize,
  handlePageSizeChange,
  loading,
  handleLoadMore,
}) => {

  return (
    <div className="Settings">
      <div className="NewsSettings">
        <div className="header">
            <h4>Change News Settings</h4> <i class="fas fa-sliders-v"></i>
        </div>
        <div className="SetTopic">
          <select
            id="topic-select"
            value={topicName}
            onChange={handleTopicChange}
          >
            <option value="India">Choose Topic (Default India)</option>
            <option value="technology">Technology</option>
            <option value="tech">Tech</option>
            <option value="iot">Internet of Things (IoT)</option>
            <option value="programming">Programming</option>
            <option value="development">Development</option>
            <option value="computing">Computing</option>
            <option value="internet">Internet</option>
            <option value="cybersecurity">Cybersecurity</option>
            <option value="artificial-intelligence"> Artificial Intelligence </option>
            <option value="machine-learning">Machine Learning</option>
            <option value="virtual-reality">Virtual Reality</option>
            <option value="cloud-computing">Cloud Computing</option>
            <option value="data-analytics">Data Analytics</option>
            <option value="e-commerce">E-Commerce</option>
            <option value="gaming">Gaming</option>
          </select>
        </div>

        <div className="SetPageSize">
          <input
            type="number"
            id="page-size-input"
            min={5}
            max={100}
            value={pageSize}
            onChange={handlePageSizeChange}
          />
          {!loading && (
            <button className="Load-more" onClick={handleLoadMore}>
              Load More
            </button>
          )}
          {loading && (
            <button className="Load-more" onClick={handleLoadMore}>
              Please Wait...
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default NewsSettings;
